__turbopack_context__.v({
  "effect": "footer-fx-module__9PcXEq__effect",
  "footerNozBob": "footer-fx-module__9PcXEq__footerNozBob",
  "footerNozHands": "footer-fx-module__9PcXEq__footerNozHands",
  "footerNozPeek": "footer-fx-module__9PcXEq__footerNozPeek",
  "footerStatusPulse": "footer-fx-module__9PcXEq__footerStatusPulse",
  "fx": "footer-fx-module__9PcXEq__fx",
  "fxBlock": "footer-fx-module__9PcXEq__fxBlock",
  "fxField": "footer-fx-module__9PcXEq__fxField",
  "fxRail": "footer-fx-module__9PcXEq__fxRail",
  "fxRows": "footer-fx-module__9PcXEq__fxRows",
  "isLive": "footer-fx-module__9PcXEq__isLive",
  "noz": "footer-fx-module__9PcXEq__noz",
  "nozHands": "footer-fx-module__9PcXEq__nozHands",
  "nozHead": "footer-fx-module__9PcXEq__nozHead",
  "nozPupil": "footer-fx-module__9PcXEq__nozPupil",
  "status": "footer-fx-module__9PcXEq__status",
  "statusDot": "footer-fx-module__9PcXEq__statusDot",
  "statusWrap": "footer-fx-module__9PcXEq__statusWrap",
  "textureBar": "footer-fx-module__9PcXEq__textureBar",
});
